const styleGuideColors = {
  white: '#fff',
  black: '#000',
  background: '#e2ecff',
  disabled: '#e3e8ed',
  highlight: '#d9e0f0',
  graphGreyStrokes: '#bac3d4',
  graphYellow: '#fcc180',
  alertError: '#db0f00',
  correctGreen: '#36b37e',
  baxterBrandBaxterBlue: '#039',
  baxterBrandNavy: '#001a72',
  placeholder: '#858fab',
  baxterBrandCyan: '#009fda',
  baxterBrandTerracota: '#be531c',
  baxterBrandOrange: '#fa8300',
  baxterBrandPurple: '#652d86',
  baxterBrandTeal: '#00857d',
  baxterBrandGreen: '#4a773c',
  baxterBrandBaxterGray: '#54585a',
  backgroundProgress: '#f0f0f7',
  alrertDark: '#8d150c'
};

export default styleGuideColors;
